module.exports = __webpack_public_path__ + "img/curitiba_background_hero.a3fdc8c0.png";